import React, { memo } from "react"
import { Text, Flex, Button, BoxProps } from "@chakra-ui/react"
import { ReviewStarRating } from "@app/components/Product/ProductReviews/ReviewStarRating"

type Props = {
  totalReviews: number
  averageReview: number
  reviewsRef: React.RefObject<HTMLDivElement>
} & BoxProps

export const ProductReviewsPreview: React.FC<Props> = memo(({ totalReviews, averageReview, reviewsRef, ...boxProps }) => {
  const handleScrollToReviews = () => {
    if (reviewsRef.current) reviewsRef.current?.scrollIntoView({ behavior: "smooth" })
  }

  return totalReviews ? (
    <>
      <Flex as={Button} onClick={handleScrollToReviews} gap={2} {...boxProps} alignItems="center">
        <ReviewStarRating numOfStars={averageReview} />
        <Text>{`(${totalReviews})`}</Text>
      </Flex>
    </>
  ) : null
})
